/*!
 * vue-no-ssr v0.2.2
 * (c) 2017-present egoist <0x142857@gmail.com>
 * Released under the MIT License.
 */
'use strict';

var index = {
  name: 'no-ssr',
  props: ['placeholder'],
  data: function data() {
    return {
      canRender: false
    }
  },
  mounted: function mounted() {
    this.canRender = true;
  },
  render: function render(h) {
    if (this.canRender) {
      if (
        process.env.NODE_ENV === 'development' &&
        this.$slots.default &&
        this.$slots.default.length > 1
      ) {
        throw new Error('[vue-no-ssr] You cannot use multiple child components')
      }
      return this.$slots.default && this.$slots.default[0]
    }
    return h(
      'div',
      {
        class: ['no-ssr-placeholder']
      },
      this.$slots.placeholder || this.placeholder
    )
  }
};

module.exports = index;
